import { graphql } from '@/gql';
import type { OperatorSignInOutMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const operatorSignInOut = async ({
  operatorId,
  slackId,
  cmd,
  onlineExclusivePhoneNumbers,
  departments,
}: OperatorSignInOutMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      operatorId,
      slackId,
      cmd,
      onlineExclusivePhoneNumbers,
      departments,
    },
    mutation: graphql(`
      mutation OperatorSignInOut(
        $operatorId: String
        $slackId: String
        $cmd: String!
        $onlineExclusivePhoneNumbers: [String!]
        $departments: [String!]!
      ) {
        operatorSignInOut(
          operatorId: $operatorId
          slackId: $slackId
          cmd: $cmd
          onlineExclusivePhoneNumbers: $onlineExclusivePhoneNumbers
          departments: $departments
        )
      }
    `),
  });

  return response.data?.operatorSignInOut ?? '';
};
